import { Link } from '@liveauctioneers/hammer-ui-core/link';
import { Caption } from '@liveauctioneers/hammer-ui-core/text';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';
import { memo } from 'react';

import { useIsMobileLayout } from '@/hooks/useIsMobileLayout';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';
import { getDeskSupportLink } from '@/utils/urls';

type Props = {};

const SearchErrorComponent = () => {
    const isMobile = useIsMobileLayout();
    const formatMessage = useAppFormatMessage();

    return (
        <Caption
            className={cn(
                'h-[158px] w-full border border-border-secondary pt-2xl text-center tracking-[0.2px] [&_a]:cursor-pointer [&_a]:underline',
                { 'h-[127px] px-md pt-md pb-xl': isMobile }
            )}
            color="secondary"
        >
            <div>{formatMessage(['search_error_1'])}</div>
            <div>
                <span>{formatMessage(['search_error_2'])}</span>
                <Link
                    href={getDeskSupportLink()}
                    rel="noopener"
                    target="_blank"
                >
                    {formatMessage(['search_error_contact_support'])}
                </Link>
                <span>{formatMessage(['search_error_3'])}</span>
            </div>
        </Caption>
    );
};

export const SearchError = memo<Props>(SearchErrorComponent);
